import { ImmutableUtils } from '@atlassian/mpac-utils';
import { Option } from 'funfix-core';
import { List } from 'immutable';
const formatInstalledAppsToMap = (locallyInstalledApps, globallyInstalledApps) => {
  const installedApps = Option.map2(locallyInstalledApps.result.flatMap(a => a.toOption()), globallyInstalledApps.result.flatMap(a => a.toOption()), (locallyInstalledAppsResult, globallyInstalledAppsResult) => locallyInstalledAppsResult.installedApps.concat(globallyInstalledAppsResult.installedApps)).getOrElse(List());

  // TODO https://ecosystem.atlassian.net/browse/FMI-550
  return ImmutableUtils.listToMap(installedApps, app => app.details.key ? app.details.key : app.details.ecosystemCloudAppId || '');
};
export default formatInstalledAppsToMap;